// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","h2":"Modal_h2__s-To6","modalContent":"Modal_modalContent__axM59"};